import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FiUser, FiLogOut } from 'react-icons/fi';

export const Navbar: React.FC = () => {
  const { isAuthenticated, user, logout } = useAuth();

  const getDashboardLink = () => {
    if (!user?.role) return '/';
    switch (user.role) {
      case 'tedy-admin':
        return '/admin/dashboard';
      case 'tedy-partner':
        return '/partner/dashboard';
      case 'tedy-student':
        return '/student/dashboard';
      default:
        return '/';
    }
  };

  return (
    <nav className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <img
                className="h-8 w-auto"
                src="/TalentED_logo_colour.svg"
                alt="TalentED YYC"
              />
            </Link>

            {isAuthenticated && (
              <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
                <Link
                  to={getDashboardLink()}
                  className="inline-flex items-center px-1 pt-1 border-b-2 border-tedy-red text-sm font-medium text-gray-900"
                >
                  Dashboard
                </Link>
                <Link
                  to="/assessments"
                  className="inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300"
                >
                  Assessments
                </Link>
                <Link
                  to="/reports"
                  className="inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300"
                >
                  Reports
                </Link>
              </div>
            )}
          </div>

          <div className="flex items-center">
            {isAuthenticated && user ? (
              <div className="flex items-center space-x-4">
                <div className="text-sm">
                  <span className="text-gray-500">Signed in as </span>
                  <span className="text-tedy-black font-medium">
                    {user.name || user.email}
                  </span>
                  {user.organization && (
                    <span className="text-gray-500 ml-1">
                      ({user.organization})
                    </span>
                  )}
                </div>
                <div className="flex items-center space-x-2">
                  <a
                    href={import.meta.env.VITE_AUTH_MGMT_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-500 hover:text-tedy-red p-2 rounded-full transition-colors"
                    title="Profile Settings"
                  >
                    <FiUser className="h-5 w-5" />
                  </a>
                  <Link
                    to="/logout"
                    className="text-gray-500 hover:text-tedy-red p-2 rounded-full transition-colors"
                    title="Sign Out"
                  >
                    <FiLogOut className="h-5 w-5" />
                  </Link>
                </div>
              </div>
            ) : (
              <Link
                to="/login"
                className="text-tedy-red hover:text-opacity-80 font-medium"
              >
                Sign in
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};
